type Props = {
  children: JSX.Element;
};

export const IconWrapper = ({ children }: Props) => {
  return (
    <span style={{ position: 'relative' }}>
      <span
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        {children}
      </span>
    </span>
  );
};
